export interface ProfileImage {
    imageName: string | null;
    fallback: ProfileImageFallback | null;
}

export interface ProfileImageFallback {
    type: ProfileImageFallbackType;
}

export enum ProfileImageFallbackType {
    Default = "Default",
    Initials = "Initials"
}

export interface ProfileImageInitials extends ProfileImageFallback {
    initials: string
    color: number
}